<template>
  <div>
    <div class="md-layout md-size-100 md-small-size-100">
      <StatCardWithIcon
        v-for="card in this.billingsTabStats"
        @emit="emit"
        :title="card.title"
        :value="card.value"
        :icon="card.icon"
        :color="card.color"
        :key="card.title"
        :filter="card.filter"
        :footer="card.footer">
      </StatCardWithIcon>
    </div>

    <div class="md-layout boxed-category md-size-100 md-small-size-100" v-if="this.billingsTabGraph.userBillingData">
      <div class="md-layout-item md-size-100 md-small-size-100 graph-boxed" v-if="this.billingsTabGraph.userBillingData">
        <md-subheader>Users Billing</md-subheader>
        <div class="apex-chart-wrapper" v-if="this.billingsTabGraph.userBillingData ? this.billingsTabGraph.userBillingData.showChart : false">
          <vue-apex-charts width="100%" type="bar" :options="computedOptionsUserBilling" :series="userBilling"></vue-apex-charts>
        </div>
      </div>

      <div class="md-layout-item md-size-100 md-small-size-100 graph-boxed" v-if="this.billingsTabGraph.podBillingData">
        <md-subheader>Pods Billing</md-subheader>
        <div class="apex-chart-wrapper" v-if="this.billingsTabGraph.podBillingData ? this.billingsTabGraph.podBillingData.showChart : false">
          <vue-apex-charts width="100%" type="bar" :options="computedOptionsPodBilling" :series="podBilling"></vue-apex-charts>
        </div>
      </div>

      <div class="md-layout-item md-size-100 md-small-size-100 graph-boxed" v-if="this.billingsTabGraph.billingTypeData">
        <md-subheader>Billing Types</md-subheader>
        <div class="apex-chart-wrapper" v-if="this.billingsTabGraph.billingTypeData ? this.billingsTabGraph.billingTypeData.showChart : false">
          <vue-apex-charts width="100%" type="bar" :options="computedOptionsBillingType" :series="billingType"></vue-apex-charts>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import StatCardWithIcon from "./ReportingDashboard/components/StatCardWithIcon";
import BarChart from "./ReportingDashboard/charts/BarChart";
import LineChart from "./ReportingDashboard/charts/LineChart";
import NotificationCard from "../components/Cards/NotificationCard";
import LoadingIconTextButton from "@/components/LoadingIconTextButton";
import filters from '../components/utils/filters'
import VueApexCharts from 'vue-apexcharts'

export default {
  components: {
    StatCardWithIcon,
    BarChart,
    NotificationCard,
    LineChart,
    LoadingIconTextButton,
    VueApexCharts
  },
  props: ['billingsTabStats','billingsTabGraph'],
  data() {
    return {
      graphOption: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          datalabels: {
            color: 'black',
            backgroundColor: 'white',
            textAlign: 'center',
            borderRadius: 5,
          }
        },
      },
    }
  },
  computed: {
    computedOptionsUserBilling() {
      return {
        chart: {
          type: 'bar',
          animations: {
            speed: 200
          },
          toolbar: {
            show: true
          },
          height: '100%'
        },
        plotOptions: {
          bar: {
            distributed: true,
            horizontal: true,
            dataLabels: {
              position: 'bottom'
            },
          }
        },
        dataLabels: {
          enabled: true,
          textAnchor: 'start',
          offsetX: 0,
          style: {
            colors: ['#000000']
          },
          formatter: function (value) {
            return filters["currency"](value).replace(".00", "");
          }
        },
        xaxis: {
          type: 'category',
          categories:  this.billingsTabGraph.userBillingData ? this.billingsTabGraph.userBillingData.labels : [],
        },
        theme: {
          palette: 'palette1'
        }
      }
    },
    computedOptionsPodBilling() {
      return {
        chart: {
          type: 'bar',
          animations: {
            speed: 200
          },
          toolbar: {
            show: true
          },
          height: '100%'
        },
        plotOptions: {
          bar: {
            distributed: true,
            horizontal: true,
            dataLabels: {
              position: 'bottom'
            },
          }
        },
        dataLabels: {
          enabled: true,
          textAnchor: 'start',
          offsetX: 0,
          style: {
            colors: ['#000000']
          },
          formatter: function (value) {
            return filters["currency"](value).replace(".00", "");
          }
        },
        xaxis: {
          categories: this.billingsTabGraph.podBillingData ? this.billingsTabGraph.podBillingData.labels : []
        },
        theme: {
          palette: 'palette1'
        }
      }
    },
    computedOptionsBillingType() {
      return {
        chart: {
          type: 'bar',
          animations: {
            speed: 200
          },
          toolbar: {
            show: true
          },
          height: '100%'
        },
        plotOptions: {
          bar: {
            distributed: true,
            horizontal: true,
            dataLabels: {
              position: 'bottom'
            },
          }
        },
        dataLabels: {
          enabled: true,
          textAnchor: 'start',
          offsetX: 0,
          style: {
            colors: ['#000000']
          },
          formatter: function (value) {
            return filters["currency"](value).replace(".00", "");
          }
        },
        xaxis: {
          categories: this.billingsTabGraph.billingTypeData ? this.billingsTabGraph.billingTypeData.labels : []
        },
        theme: {
          palette: 'palette1'
        }
      }
    },
    userBilling() {
      return [
        {
          name: "Billing Amount",
          data: this.billingsTabGraph.userBillingData ? this.billingsTabGraph.userBillingData.datasets[0].data : [],
        }
      ]
    },
    podBilling() {
      return [
        {
          name: "Billing Amount",
          data: this.billingsTabGraph.podBillingData ? this.billingsTabGraph.podBillingData.datasets[0].data : []
        }
      ]
    },
    billingType() {
      return [
        {
          name: "Billing Amount",
          data: this.billingsTabGraph.billingTypeData ? this.billingsTabGraph.billingTypeData.datasets[0].data : []
        }
      ]
    },
  },
  methods: {
    ...filters,
    emit(data) {
      this.$emit('show',data);
    },
  },
  filters: {
    ...filters
  },
}

</script>
<style scoped lang="scss">
.apex-chart-wrapper {
  height: auto;
}
</style>